
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  computed: {
    errorReason() {
      return this.$route.query.reason || null
    },
  },
  head() {
    const pageTitle = `${this.$custom$t('paymentFailed.title')} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('paymentFailed.metaDescription'),
      noindex: true,
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
}
